import * as React from 'react';
import { connect } from 'react-redux';
import People from '../People/People';
import { ISpecificPeopleProps } from '../People/IPeople';
import { TTopInvestors } from './ITopInvestors';
import { TReducers } from '@features/reducers';

export class TopInvestors extends React.Component<ISpecificPeopleProps, TTopInvestors> {

  state: TTopInvestors = {
    data: this.props.people || {},
  };

  render() {
    return (
      <React.Fragment>
      {
        Object.keys(this.state.data).length !== 0 ?
          this.props.editMode ? null :
          (
            <People
              editMode={false}
              companyID={this.props.companyID}
              title="Top BF Investor"
              updateStateFromChild={() => { }}
              people={this.state.data}
              dispatch={this.props.dispatch}
            />
          )
         : null
      }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    people: store.companyReducer.companyTopInvestors,
    formDirty: store.companyReducer.formDirty,
  };
};

export default connect(mapStateToProps)(TopInvestors);
